/*
 * AuthenticatorHeader Messages
 *
 * This contains all the text for the AuthenticatorHeader component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.AuthenticatorHeader";

export default defineMessages(scope, {
  header: "Set up {authenticatorName}",
});
